import React, {Fragment, useContext, useEffect, useState} from "react";
import ModalMsg from "./components/ModalMsg";
import {LoaderContext} from "./context/LoaderContext";
import Spinner from "./components/Spinner";
import {Route, Switch, useHistory} from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import {Toast} from 'primereact/toast';
import Footer from "./components/Footer";
import axios from "axios";
import {TranslateContext} from "./context/TranslateContext";
import {AuthContext} from "./context/AuthContext";
import {AlertMsgContext} from "./context/AlertMsgContext";
import ModificaCommentoKpiController from "./features/commenti/ModificaCommentoKpiController";
import ConfFrequenzeController from "./features/frequenze/ConfFrequenzeController";
import ModificaFrequenzaController from "./features/frequenze/ModificaFrequenzaController";
import ConfImpostazioniController from "./features/impostazioni/ConfImpostazioniController";
import ModificaImpostazioneController from "./features/impostazioni/ModificaImpostazioneController";
import ConfGruppiUtenteController from "./features/gruppi-utente/ConfGruppiUtenteController";
import ModificaGruppoUtenteController from "./features/gruppi-utente/ModificaGruppoUtenteController";
import ConfLingueController from "./features/lingue/ConfLingueController";
import ConfStatiKpiController from "./features/stati_kpi/ConfStatiKpiController";
import ModificaStatoKpiController from "./features/stati_kpi/ModificaStatoKpiController";
import ConfUtentiController from "./features/utenti/ConfUtentiController";
import ModificaUtenteController from "./features/utenti/ModificaUtenteController";
import ExportKpiController from "./features/esportazione_kpi/ExportKpiController";
import ConfKpiController from "./features/kpi/configura/ConfKpiController";
import ModificaKpiController from "./features/kpi/configura/ModificaKpiController";
import ConfClassiMacrocategorieController from "./features/macrocategorie/ConfClassiMacrocategorieController";
import ModificaClasseMacrocategoriaController from "./features/macrocategorie/ModificaClasseMacrocategoriaController";
import ModificaStrutturaClasseMacrocategoriaController
    from "./features/macrocategorie/ModificaStrutturaClasseMacrocategoriaController";
import ModificaMacrocategoriaController from "./features/macrocategorie/ModificaMacrocategoriaController";
import InserisciMacrocategoriaFigliaController from "./features/macrocategorie/InserisciMacrocategoriaFigliaController";
import ConfClassiTipiImpExpController from "./features/tipi_imp_exp_dati/ConfClassiTipiImpExpController";
import ModificaClasseImpExpController from "./features/tipi_imp_exp_dati/ModificaClasseImpExpController";
import ModificaStrutturaClasseImpExpController
    from "./features/tipi_imp_exp_dati/ModificaStrutturaClasseImpExpController";
import ModificaTipoImpExpController from "./features/tipi_imp_exp_dati/ModificaTipoImpExpController";
import InserisciTipoImpExpFiglioController from "./features/tipi_imp_exp_dati/InserisciTipoImpExpFiglioController";
import HomeContainer from "./features/home/HomeContainer";
import Home from "./features/home/Home";
import InfoKpiController from "./features/kpi/rendicontazione/InfoKpiController";
import ModificaDatiKpiController from "./features/kpi/rendicontazione/ModificaDatiKpiController";
import UploadDocumentiKpiController from "./features/kpi/rendicontazione/UploadDocumentiKpiController";
import Error from "./features/errori/Error";
import LoginController from "./features/login/LoginController";
import LoginSso from "./features/login/LoginSso";
import AttivaAccountController from "./features/attiva_account/AttivaAccountController";
import ResetPasswordController from "./features/recupera_pwd/ResetPasswordController";
import RecuperaPwdController from "./features/recupera_password/RecuperaPwdController";
import NsMenuController from "./features/menu/NsMenuController";
import ListKpiStandardController from "./features/kpi/rendicontazione/ListKpStandardiController";
import ListKpiCarbonController from "./features/kpi/rendicontazione/ListKpCarbonController";
import {getDecodeJwt, getUtenteFromToken} from "./utility/common";
import {callRefreshToken} from "./features/login/services/AuthServices";
import ConfTopicController from "./features/topic/ConfTopicController";


function ApplicationBody() {

    const [show, setShow] = useState(false);
    const [interceptorOk, setInterceptorOk] = useState(false);
    const [errMessage, setErrMessage] = useState('');

    const history = useHistory()

    const {lingua, translate, setLoadingNewLang} = useContext(TranslateContext);
    const {resetSpinner, loading, startChiamata, endChiamata} = useContext(LoaderContext);
    const {handleLogout, inizializingUser, annoKpi, isLogged} = useContext(AuthContext);

    const {refToast, clearAlert} = useContext(AlertMsgContext);

    let isRefreshing = false;
    let pendingRequests = [];

    function isTokenExpired(refreshToken) {
        let token = getDecodeJwt(refreshToken)
        // Dichiaro il token scaduto dieci secondi prima che lo sia davvero
        return ((token.exp * 1000) - 10000) <= new Date().getTime();
    }

    function appendHeaders(req, accessToken, lingua, newAnnoKpi) {
        if (req) {
            req.headers['Content-Type'] = 'application/json';
            req.headers['anno-kpi'] = localStorage.getItem('ns-anno-kpi');

            if (accessToken && accessToken !== '') {
                req.headers['jwt'] = accessToken;
            }

            if (lingua && lingua !== '') {
                req.headers['lang'] = lingua;
            }
        }
    }

    /*useEffect(() => {
        if (inizializingUser === true) {
            startChiamata();
        } else {
            resetSpinner();
        }
    }, [inizializingUser]);*/

    useEffect(() => {
        let interceptor;
        let interceptorResp;

        if (isLogged) {
            if (lingua && lingua !== '') {
                // For GET requests
                interceptor = axios.interceptors.request.use(
                    async (req) => {
                        const accessToken = localStorage.getItem('ns-access-token');
                        const refreshToken = localStorage.getItem('ns-refresh-token');

                        appendHeaders(req, accessToken, lingua, annoKpi);

                        if (accessToken && accessToken !== ''
                            && refreshToken && refreshToken !== ''
                            && isTokenExpired(accessToken)
                            && !req.url.endsWith("/refresh-token")) {

                            if (!isRefreshing) {
                                isRefreshing = true;
                                pendingRequests = [];

                                if (refreshToken && refreshToken !== '') {
                                    let usr = getUtenteFromToken(refreshToken);

                                    callRefreshToken(usr.id_utente, refreshToken)
                                        .then(response => {
                                            // Aggiorna i token
                                            if (response?.data) {
                                                if (response?.data?.result === 0) {
                                                    localStorage.setItem('ns-refresh-token', response.data.data.refresh_token);
                                                    localStorage.setItem('ns-access-token', response.data.data.access_token);
                                                }
                                                isRefreshing = false;
                                                pendingRequests.forEach(({request, resolve, reject}) => {
                                                    appendHeaders(request, response.data.data.access_token, lingua, annoKpi);
                                                    resolve(request);
                                                });
                                                pendingRequests = [];
                                            }
                                        })
                                        .catch(error => {
                                            console.error(error);
                                            resetSpinner();
                                            isRefreshing = false;
                                            pendingRequests.forEach(({reject}) => {
                                                reject(error);
                                            });
                                            pendingRequests = [];
                                        });
                                }
                            }

                            return new Promise((resolve) => {
                                pendingRequests.push({
                                    request: req, resolve, reject: () => { /* Handle request failure */
                                    }
                                });
                            });
                        }

                        startChiamata();
                        return req;
                    },
                    (err) => {
                        setShow(true)
                        setErrMessage(translate("Si è verificato un errore. Riprovare più tardi."));
                        resetSpinner()
                        return Promise.reject(err);
                    }
                );
                setInterceptorOk(true);
                setLoadingNewLang(false);
            }

            interceptorResp = axios.interceptors.response.use(
                (res) => {
                    // Token scaduto o non valido
                    if (res.data && res.data.result && (res.data.result === -100 || res.data.result === -101)) {
                        console.log('Token non più valido')

                        // Logout utente
                        logoutUtente();
                    }

                    // Token scaduto o non valido
                    if (res.data && res.data.result && (res.data.result === -102)) {
                        console.log('Sessione scaduta')
                        setErrMessage(translate("È stata attivata una nuova sessione per il tuo utente. L'attuale sessione non è più valida"));
                        setShow(true)

                        // Logout utente
                        logoutUtente();
                    }
                    endChiamata();
                    return res;
                },
                (err) => {
                    setShow(true);

                    // il messaggio che arriva dal backend è già tradotto
                    let message = err.response?.data?.description || translate("Si è verificato un errore. Riprovare più tardi.");

                    setErrMessage(message);
                    resetSpinner();
                    return Promise.reject(err);
                }
            );
        }

        // Cleanup: rimuove l'interceptor precedente quando il componente viene smontato o la lingua cambia
        return () => {
            if (interceptor) {
                axios.interceptors.request.eject(interceptor);
            }
            if (interceptorResp) {
                axios.interceptors.response.eject(interceptorResp);
            }
        };
    }, [lingua, annoKpi, isLogged]);

    function logoutUtente() {
        handleLogout()
        history.push("/login");
        resetSpinner();
    }

    return (
        <Fragment>
            {
                interceptorOk &&
                <Fragment>
                    <NsMenuController/>
                    <ModalMsg
                        show={show}
                        handleClose={() => setShow(false)}
                        testo={errMessage}/>

                    {/* Gestione spinner di caricamento */}
                    <Spinner loading={loading()}/>
                    <Toast ref={refToast} position="top-center" onRemove={clearAlert}/>

                    {
                        // Carico le rotte solo quando l'authContext è inizializzato
                        inizializingUser === false &&
                        <div className="ns-container">
                            <Switch>
                                <Route path="/reset-password/:token"
                                       render={() => <ResetPasswordController/>}/>
                                <Route path="/attiva-account/:token"
                                       render={() => <AttivaAccountController/>}/>
                                <Route path="/recuperaPwd" render={() => <RecuperaPwdController/>}/>
                                <Route path="/errore" render={() => <Error/>}/>
                                <Route path="/sso" render={() => <LoginSso/>}/>
                                {/* componente fake intermedio utilizzato per i redirect su home */}
                                <PrivateRoute path="/home-container" component={HomeContainer}/>
                                <PrivateRoute path="/home" component={Home}/>
                                {/*<PrivateRoute path="/conf-ruoli" component={ConfRuoli}/>
                            <PrivateRoute path="/upd-ruolo/:id?" component={ModificaRuolo}/>*/}
                                <PrivateRoute path="/conf-utenti" component={ConfUtentiController}/>
                                <PrivateRoute path="/upd-utente/:id?" component={ModificaUtenteController}/>
                                <PrivateRoute path="/conf-parametri" component={ConfImpostazioniController}/>
                                <PrivateRoute path="/upd-parametro/:id?"
                                              component={ModificaImpostazioneController}/>
                                <PrivateRoute path="/conf-classi-macrocategorie"
                                              component={ConfClassiMacrocategorieController}/>
                                <PrivateRoute path="/upd-classe-macrocategoria/:id?"
                                              component={ModificaClasseMacrocategoriaController}/>
                                <PrivateRoute path="/upd-struttura-classe-macrocategoria"
                                              component={ModificaStrutturaClasseMacrocategoriaController}/>
                                <PrivateRoute path="/conf-frequenze-comp" component={ConfFrequenzeController}/>
                                <PrivateRoute path="/upd-frequenza-comp/:id?" component={ModificaFrequenzaController}/>
                                <PrivateRoute path="/conf-kpi" component={ConfKpiController}/>
                                <PrivateRoute path="/upd-kpi/:id?" component={ModificaKpiController}/>
                                <PrivateRoute path="/upd-macrocategoria/:id?"
                                              component={ModificaMacrocategoriaController}/>
                                <PrivateRoute path="/add-macrocategoria-figlia/:id?/:idClasse?"
                                              component={InserisciMacrocategoriaFigliaController}/>
                                <PrivateRoute path="/conf-classi-imp-exp" component={ConfClassiTipiImpExpController}/>
                                <PrivateRoute path="/upd-classe-imp-exp/:id?"
                                              component={ModificaClasseImpExpController}/>
                                <PrivateRoute path="/upd-struttura-classe-imp-exp"
                                              component={ModificaStrutturaClasseImpExpController}/>
                                <PrivateRoute path="/upd-tipo-imp-exp/:id?" component={ModificaTipoImpExpController}/>
                                <PrivateRoute path="/add-tipo-imp-exp-figlio/:id?/:idClasse?"
                                              component={InserisciTipoImpExpFiglioController}/>
                                <PrivateRoute path="/conf-lingue" component={ConfLingueController}/>
                                <PrivateRoute path="/conf-stati_kpi" component={ConfStatiKpiController}/>
                                <PrivateRoute path="/upd-stato-kpi/:id?" component={ModificaStatoKpiController}/>
                                <PrivateRoute path="/list-kpi" component={ListKpiStandardController}/>
                                <PrivateRoute path="/list-kpi-carbon" component={ListKpiCarbonController}/>
                                <PrivateRoute path="/info-kpi/:id?/:idTipoImport?" component={InfoKpiController}/>
                                <PrivateRoute path="/upd-dati-kpi/:id?/:idTipoImport?"
                                              component={ModificaDatiKpiController}/>
                                <PrivateRoute path="/add-commento-kpi/:idKpi?/:idTipoImport?/:idCommento?"
                                              component={ModificaCommentoKpiController}/>
                                <PrivateRoute path="/conf-gruppi-utente" component={ConfGruppiUtenteController}/>
                                <PrivateRoute path="/upd-gruppo-utente/:id?"
                                              component={ModificaGruppoUtenteController}/>
                                <PrivateRoute path="/add-documento-kpi/:idKpi?/:idTipoImport?"
                                              component={UploadDocumentiKpiController}/>
                                <PrivateRoute path="/export-kpi" component={ExportKpiController}/>
                                <PrivateRoute path="/conf-topics" component={ConfTopicController}/>
                                {/* Default: Login */}
                                <Route render={() => <LoginController/>}/>
                            </Switch>
                        </div>
                    }
                    <Footer/>
                </Fragment>
            }
        </Fragment>
    )
}

export default ApplicationBody;